/**
 * @ author kunnisser
 * @ date 2018/3/14
 * @ description: 设置mock数据接口
 */
import miniProgramRequest from "./miniprogramRequest";
import Axios from "axios";
import {
  MOCK_PATH,
  ACTIVE_MOCK_PATH,
  LUCK_DRAW_PATH,
  SHARE_PATH,
  WX_PAYMENT_URL,
  BEE_APPROVE_PATH,
  LUCK_DRAW_PATH_NEWPOINT
} from "../utils/dispatchEnv";
import qs from "qs";
import md5 from "js-md5";
import { uuid } from "vue-uuid";
import functionTools from "@/utils/functionTools";
import Jsbridge from "../utils/jsbridge";
const jsbridge = new Jsbridge();
const TIMEOUT = 14e3;
let timeNum = "";
const urlParams = qs.parse(window.location.href.split("?")[1]);

const isMiniProgram = functionTools.getUrlParam("isMiniProgram");

const getSign = async (params, time) => {
  const ordered = {};
  const newParams = {
    ...params,
    userId: params.userId || "",
    timestamp: time
  };
  Object.keys(newParams)
    .sort()
    .forEach(function(key) {
      ordered[key] = newParams[key];
    });
  const paramsStr = `${qs.stringify(ordered, { encode: false })}`;
  return new Promise((resolve, reject) => [
    resolve({
      data: md5(paramsStr)
        .toLocaleUpperCase()
        .substr(0, 18),
      time
    })
  ]);
};
Axios.interceptors.request.use(async request => {
  timeNum = +new Date();
  const nonce = uuid.v4();
  if (request.params) {
    request.params.nonce = nonce;
    for (const key in request.params) {
      if (!request.params[key]) {
        delete request.params[key];
      }
    }
  }
  if (request.data) {
    const resqData = { ...qs.parse(request.data) };
    for (const key in resqData) {
      if (!resqData[key]) {
        delete resqData[key];
      }
    }
    request.data = qs.stringify(resqData);
  }
  const params = {
    ...qs.parse(request.data),
    ...request.params,
    nonce
  };
  for (const key in params) {
    if (!params[key]) {
      delete params[key];
    }
  }
  request.data = `${request.data}&nonce=${nonce}`;
  const res = await getSign(params, timeNum);
  request.headers.timestamp = res.time;
  request.headers.signature = res.data;
  request.headers.referrer = "web";
  return request;
});

const baseAxios = isMiniProgram ? miniProgramRequest : Axios;

const getMock = url => {
  return params =>
    baseAxios.get(url, {
      params,
      timeout: TIMEOUT,
      headers: {
        appVersion: functionTools.getUrlParam("version") || "5.2.0"
      }
    });
};

const postMock = url => {
  return params => {
    const newParams = qs.stringify(params);
    return baseAxios.post(url, newParams, {
      timeout: TIMEOUT,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;",
        appVersion: functionTools.getUrlParam("version") || "5.2.0"
      }
    });
  };
};
const getUserAddress = getMock(MOCK_PATH + "/invoice/userAddressDetail");
// 获取用户抽奖后的抽奖信息
const getPrizeInfo = postMock(ACTIVE_MOCK_PATH + "/activityLottery/info/qry");

// 微信分享
const wxShare = getMock(SHARE_PATH + "/activity/official/ident");

// 奖品列表
const getPrizeList = getMock(LUCK_DRAW_PATH + "/prize/list");
// 查看奖品列表
const myGiftLists = postMock(LUCK_DRAW_PATH + "/prizeLog/list");
// 填写收件信息
const addressInfos = postMock(LUCK_DRAW_PATH + "/prizeLog/setAddress");
// 抽奖结果
const getUserLotty = postMock(LUCK_DRAW_PATH + "/lotty/user");
// 获取抽奖机会
const getLotteryChance = postMock(LUCK_DRAW_PATH + "/lottyChance/user");
// 获取验证码
const getValiCode = getMock(LUCK_DRAW_PATH + "/identifycode/send");
// 注册
const register = getMock(LUCK_DRAW_PATH + "/login/user");
// 查询所有中奖奖品
const getCarouselList = getMock(LUCK_DRAW_PATH + "/prizeLog/carouselList");
// 增加分享次数
const addPrize = getMock(LUCK_DRAW_PATH + "/userLottyChance/share/add");
// 增加分享次数
const getPhone = getMock(LUCK_DRAW_PATH + "/useraccount/get");
/* 用户中心 */
// 增加亲吻节活动信息
const getActivity = getMock(LUCK_DRAW_PATH + "/activity/getActivityInfo");
// 获取广告活动背景图轮播图5.0新
const getAdvertisments = getMock(MOCK_PATH + "/advertisement/list/qry");
// 828登录接口
const loginExUser = getMock(LUCK_DRAW_PATH + "/loginEx/user");
// 获取活动信息（星友汇聚闪耀银河）
const getActivityInfoUser = getMock(
  LUCK_DRAW_PATH + "/activity/getActivityInfo/user"
);

// 裂变活动登陆
const vipFissionLogin = postMock(LUCK_DRAW_PATH + "/vipFission/activity/login");
const vipFissionInviteList = postMock(LUCK_DRAW_PATH + "/activity/invite/get");
// 首次购买会员
const payment = postMock(LUCK_DRAW_PATH + "/payment/pay");
// 更新订单状态
const payOrderUpdate = postMock(LUCK_DRAW_PATH + "/payment/payOrderUpdate");
// 获取邀请人信息
const inviteUser = postMock(LUCK_DRAW_PATH + "/activity/inviteUser/get");
// H5系统参数接口v5.8.0
const getSystemInfo = postMock(MOCK_PATH + "/system/systemInfo");

// 充电送红包
const getRedPackage = postMock(LUCK_DRAW_PATH + "/activity/shareVoucher/get");
// 通过OpenId获取用户详细信息
const getUserDetail = getMock(LUCK_DRAW_PATH + "/mini/wxUser/detail");
// 生成海报
const getWxImage = getMock(LUCK_DRAW_PATH + "/mini/wxImage/get");
// 图片转换
const wxImageSave = postMock(LUCK_DRAW_PATH + "/mini/image/save");

// 推荐有奖活动统计
const getRecommendCount = postMock(
  LUCK_DRAW_PATH + "/recommend/getRecommendCount"
);
// 获取注册有礼邀请码
const signInviteCodeGet = postMock(
  LUCK_DRAW_PATH + "/activity/signInviteCode/get"
);

// 分享红包 送会员积分
const userIntegralAdd = postMock(LUCK_DRAW_PATH + "/user/integral/add");
// 获取用户抽奖机机会
const userLottyChanceGet = postMock(LUCK_DRAW_PATH + "/user/lottyChance/get");
// 转盘用户抽奖
const userLottyActivityLotty = postMock(
  LUCK_DRAW_PATH + "/user/lottyActivity/lotty"
);
// 扫星星 获取活动信息
const scanStarGetActivityInfo = postMock(
  LUCK_DRAW_PATH + "/scanStar/activityInfo/get"
);
// 扫星星 图片上传
const scanStarScan = postMock(LUCK_DRAW_PATH + "/scanStar/scan");
// 扫星星 领券奖励
const scanStarGetPrize = postMock(LUCK_DRAW_PATH + "/scanStar/prize/get");

// 获取实名认证状态
const getUserRealNameFlag = postMock(
  LUCK_DRAW_PATH + "/starManager/userRealNameFlag/get"
);

// 星星掌柜 获取活动详情
const starManagerGetInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/starManager/activityInfo/get"
);

// 星星掌柜 店铺排名
const getStorRank = getMock(LUCK_DRAW_PATH_NEWPOINT + "/starManager/rank/get");

// 星星掌柜 贵宾列表
const getInviterUser = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/starManager/inviterUser/get"
);

// 星星掌柜 奖励列表
const starManagerGetPrize = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/starManager/prize/get"
);

// 星星掌柜 获取用户标签
const getVipTag = postMock(LUCK_DRAW_PATH + "/starManager/userTags/get");

// 星星掌柜 添加用户标签
const setVipTag = postMock(LUCK_DRAW_PATH + "/starManager/userTags/set");

// 星星掌柜 赠送礼品
const givePrize = postMock(LUCK_DRAW_PATH + "/starManager/prize/give");

// 星星掌柜 贵宾额外信息
const getUserExtraInfo = postMock(
  LUCK_DRAW_PATH + "/starManager/userExtraInfo/get"
);

// 星星掌柜 银两分列表
const getIntegralList = postMock(
  LUCK_DRAW_PATH + "/starManager/integralList/get"
);

// 星星掌柜 获取兑换商品
const getExchangeGoodsInfo = postMock(
  LUCK_DRAW_PATH + "/starManager/exchangeGoodsInfo/get"
);

// 星星掌柜 获取我的银两分
const getStarManagerUserInfo = postMock(
  LUCK_DRAW_PATH + "/starManager/userInfo/get"
);

// 星星掌柜 兑换奖励
const exchangeGoods = postMock(LUCK_DRAW_PATH + "/starManager/goods/exchange");

// 星星掌柜 邀请校验
const inviterUserCheck = postMock(
  LUCK_DRAW_PATH + "/starManager/inviterUser/check"
);

// 星星掌柜 邀请用户
const inviterUser = postMock(LUCK_DRAW_PATH + "/starManager/user/inviter");

// 星星掌柜 用户积分列表
const getIintegralList = postMock(
  LUCK_DRAW_PATH + "/starManager/integralList/get"
);

// 新获取活动信息（充电中送红包）
const chargeSendRedPacketGetinfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/chargeSendRedPacket/activityInfo/get"
);
// 获取用户数据（充电中送红包）
export const chargeSendRedPacketUserData = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/chargeSendRedPacket/userData"
);
// 抽奖（充电中送红包）
const chargeSendRedPacketGetVoucher = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/chargeSendRedPacket/voucher/get"
);

// 微信绑定迁移-微信发送短信验证码
const wechatBindWxSendSms = postMock(MOCK_PATH + "/wechatBind/wx/sendSms");
// 微信绑定迁移-微信绑定用户
const wechatBindWxBindUser = postMock(MOCK_PATH + "/wechatBind/wx/bindUser");
// 微信绑定迁移-获取微信用户
const wechatBindWxGetWxUser = postMock(MOCK_PATH + "/wechatBind/wx/getWxUser");
// 微信绑定迁移-解除绑定用户
const wechatBindWxUnbindWxUser = postMock(
  MOCK_PATH + "/wechatBind/wx/unbindWxUser"
);
// 获取调查问卷
const getQuestionnaire = postMock(LUCK_DRAW_PATH + "/questionnaire/query");
// 提交调查问卷
const saveQuestionnaire = postMock(
  LUCK_DRAW_PATH + "/questionnaire/receiveResult"
);
// 调查问卷填写完成后领券
const questionnaireGetCoupons = postMock(
  LUCK_DRAW_PATH + "/questionnaire/getCoupons"
);
// 我要组队
const chargeTeamHitUserFormTeam = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/chargeTeamHit/user/formTeam"
);
// 随机或取消匹配接口
const chargeTeamHitUserRandomForm = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/user/randomForm"
);
// 获取随机匹配队友接口
const chargeTeamHitRandomTeammateGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/randomTeammate/get"
);
// 添加匹配队友进入队伍接口
const chargeTeamHitRandomTeammateAdd = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/randomTeammate/add"
);
// 参加队伍接口
const chargeTeamHitTeamJoin = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/team/join"
);
// 组队打榜活动信息接口
const chargeTeamHitActivityInfoGet = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/chargeTeamHit/activityInfo/get"
);
// 获取打榜排行榜
const chargeTeamHitRankmMoneyGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/rank/money/get"
);
// 获取活动排行榜
const chargeTeamHitRankGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/rank/get"
);
// 修改队伍名称
const chargeTeamHitTeamUpdateName = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/team/updateName"
);
// 知道组队成功奖品
const chargeTeamHitPrizeRead = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/prize/read"
);
// 获取用户基本信息--活动
const userGetBaseInfo = getMock(LUCK_DRAW_PATH + "/user/getBaseInfo");
// 查询成功组队队伍信息 （最近10条）
const chargeTeamHitSuccessTeamGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/successTeam/get"
);
// 查询用户组队状态
const chargeTeamHitActivitySimpleInfoGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/activitySimpleInfo/get"
);
// 成功发奖记录
const chargeTeamHitSuccessRecordGet = getMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/successRecord/get"
);
/** 组队二期 */
// 踢队友
const chargeTeamHitTeammateBreak = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/teammate/break"
);
// 留言板列表
const chargeTeamHitMessageList = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/message/list"
);
// 新增留言
const chargeTeamHitMessageAdd = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/message/add"
);
// 用户充电记录
const chargeTeamHitUserChargeLogs = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/user/chargeLogs"
);
// shareInfo
const chargeTeamHitShareInfoGet = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/shareInfo/get"
);
// 开启冲刺任务
const chargeTeamHitSprintTaskOpen = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/sprintTask/open"
);
// 标记任务开启
const chargeTeamHitSuccessTeamReadTask = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/successTeam/readTask"
);
// 退出队伍
const chargeTeamHitTeamRetreat = postMock(
  LUCK_DRAW_PATH + "/chargeTeamHit/team/retreat"
);
// 获取用户信息
const getWxUser = getMock(LUCK_DRAW_PATH + "/activity/eggShell/getUserInfo");
// 参加签到活动
const joinSignInActivity = getMock(
  LUCK_DRAW_PATH + "/signInActivity/joinSignInActivity"
);
// 校验是否参与签到活动
const checkIsJoinSignInActivity = getMock(
  LUCK_DRAW_PATH + "/signInActivity/checkIsJoinSignInActivity"
);
// 获取签到页信息
const signInActivityGetSignInInfo = getMock(
  LUCK_DRAW_PATH + "/signInActivity/getSignInInfo"
);
// 电量卡翻牌
const signInActivityPokerCards = getMock(
  LUCK_DRAW_PATH + "/signInActivity/pokerCards"
);

// 摇一摇中奖纪录
const shakeActivityGiftRecordFind = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/giftRecord/find"
);
// 摇一摇卡使用接口
const shakeActivityCardExchange = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/card/exchange"
);
// 摇一摇卡商品列表
const shakeActivityGoodsFind = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/goods/find"
);
// 摇一摇抽奖接口
const shakeActivityDrawLottery = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/shakeGift/get"
);
// 摇一摇查询所有人中奖奖品
const shakeActivityCarouselList = postMock(
  LUCK_DRAW_PATH + "/prizeLog/carouselList"
);
// 摇一摇查询个人活动信息
const shakeActivitygiftSummaryList = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/giftSummary/get"
);
// 摇一摇 分享增加次数
const shakeActivityShare = postMock(LUCK_DRAW_PATH + "/shakeActivity/share");
// 摇一摇 劵
const shakeActivityCoupon = getMock(
  LUCK_DRAW_PATH + "/shakeActivity/findmyTicketList"
);
// 摇一摇卡兑换记录
const shakeActivityGoodLogList = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/h5/goods/log/list"
);
// 摇一摇卡给别人助力
const shakeActivityGiveHelp = getMock(
  LUCK_DRAW_PATH + "/shakeActivity/powerCoupon/task/power"
);
// 摇一摇卡活动详情
const shakeActivityDetail = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/activityInfo/get"
);
// 摇一摇卡活动兑换劵
const shakeActivityVipCoupon = postMock(
  LUCK_DRAW_PATH + "/shakeActivity/findmyVipList"
);
// 摇一摇助力卡详情
const shakeActivityCardDetail = getMock(
  LUCK_DRAW_PATH + "/shakeActivity/powerCoupon/task/info"
);
// 完成提交邀请任务
const commitInviteTask = getMock(
  LUCK_DRAW_PATH + "/surpriseActivity/commitInviteTask"
);
// 直播获取userSign
const getUserSign = getMock(LUCK_DRAW_PATH + "/tencentWebLive/getUserSign");
// 获取im userId
const getImUserId = getMock(LUCK_DRAW_PATH + "/im/user/get");
// 获取用户爱星值
const getUserIntegral = getMock(LUCK_DRAW_PATH + "/webLive/getUserIntegral");
// 直播打赏
const rewardWebLive = getMock(LUCK_DRAW_PATH + "/webLive/rewardWebLive");
// 获取直播奖品列表
const getRewardInfoList = getMock(
  LUCK_DRAW_PATH + "/webLive/getRewardInfoList"
);
// 获取直播轮播图
const getCarouserPicBo = getMock(LUCK_DRAW_PATH + "/webLive/getCarouserPicBo");
// 推流端直播开始
const webLiveStart = getMock(LUCK_DRAW_PATH + "/webLive/webLiveStart");
// 推流端直播结束
const webLiveEnd = getMock(LUCK_DRAW_PATH + "/webLive/webLiveEnd");

// 小蜜蜂 车辆认证列表
const carCerList = postMock(BEE_APPROVE_PATH + "/api/car/get/carCertification");
// 小蜜蜂 识别二维码
const discernYard = postMock(BEE_APPROVE_PATH + "/api/car/identify/qrCode");
// 小蜜蜂 保存信息
const saveCarInfo = postMock(
  BEE_APPROVE_PATH + "/api/car/save/carCertification"
);
// 小蜜蜂 获取所有车系
const getAllBrand = postMock(BEE_APPROVE_PATH + "/api/car/get/allBrand");
// 小蜜蜂 搜索车系
const geCarSeacrh = postMock(BEE_APPROVE_PATH + "/api/car/get/allSeries");
// 小蜜蜂 其他车型车系
const elseCarSubmit = postMock(BEE_APPROVE_PATH + "/api/car/model/feedback");
// 小蜜蜂 上传oss获取token
const recognitionLicensePlate = postMock(
  BEE_APPROVE_PATH + "/api/car/identify/licensePlate"
);
// 小蜜蜂 上传oss获取token
const queryDateByStubid = postMock(
  BEE_APPROVE_PATH + "/api/car/query/chargeOrder"
);

// 低效桩群促活 模板详情
export const inefficiencyPromote = getMock(
  LUCK_DRAW_PATH + "/pileGroup/promotion/info"
);
// 获取奖励进度
export const getAwardporss = getMock(
  LUCK_DRAW_PATH + "/pileGroup/promotion/charge/sum"
);
// 获取低效促活庄群列表
export const getStationPromotionList = getMock(
  LUCK_DRAW_PATH + "/pileGroup/promotion/page"
);
// 领取奖励
export const drawAwArd = getMock(
  LUCK_DRAW_PATH + "/pileGroup/promotion/sendPrize"
);
// 碳迹公益--参加活动| 1.普通项目贡献积分、2.参加MIO联合项目、3.参加福利兑换
export const activityJoin = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/activity/join"
);
// 碳迹公益--信息--账户
export const activityGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/account/get"
);
// 碳迹公益--收集积分
export const integralCollect = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/integral/collect"
);
// 碳迹公益--账户记录
export const ctpwRecordGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/record/get"
);
// 碳迹公益--项目信息
export const ctpwProjectList = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/project/get"
);
// 碳迹公益--记录--待领取积分
export const ctpwUnclaimedGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/unclaimed/get"
);
// 碳迹公益--信息--徽章
export const ctpwBadgeGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/badge/get"
);
// 碳迹公益--信息--福利
export const ctpwGoodsGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/goods/get"
);
// 碳迹公益--信息--MIO项目
export const mioProjectGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/mio/project/get"
);
// 普通项目信息查询
export const projectGetOne = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/ctpw/project/get/one"
);

// 7.6.0
// 获取红包雨列表
export const redPacketWarList = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redPacketWar/list"
);
// 红包雨 获取今日中奖名单
// const redPacketWarList = getMock(LUCK_DRAW_PATH_NEWPOINT + '/redPacketWar/list')
export const getWinningUser = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redPacketWar/getWinningUser"
);
export const lockUser = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redPacketWar/lockUser"
);
// 本场红包雨是否已开启提醒
export const redPacketWarReminderGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redPacketWar/reminder/get"
);
// 本场红包雨提醒开启/关闭
export const redPacketWarReminderSet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redPacketWar/reminder/set"
);
// 获取红包雨活动首页数据
export const getAllInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redEnvelopeRain/info"
);
// 设置红包闹钟
export const setClockTime = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redEnvelopeRain/reminder/set"
);
// 活动抽奖
export const luckyDraw = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redEnvelopeRain/lottery"
);
// 获取红包雨用户数据
export const getRedEnvUserInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redEnvelopeRain/userData"
);
// 获取红包雨用户数据
export const getMyRedEnvUserInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/redEnvelopeRain/giftRecord/find"
);
// 加入调峰活动
export const adjustPeakJoin = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/adjustPeak/join"
);
// 调峰活动详情
export const adjustPeakInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/adjustPeak/info"
);
// 7.9.0 大转盘 普通项目信息查询
export const lotteryTurntableGetPrizeList = getMock(
  LUCK_DRAW_PATH + "/lotteryTurntable/info"
);
// 7.9.0 大转盘 // 获取用户抽奖机机会
export const lottyChanceGet = getMock(
  LUCK_DRAW_PATH + "/lotteryTurntable/userData"
);
// 7.9.0 大转盘 // 转盘用户抽奖
export const lottyActivityLotty = getMock(
  LUCK_DRAW_PATH + "/lotteryTurntable/lottery"
);
// 7.9.0 大转盘 // 查询所有中奖奖品
export const lotteryGetCarouselList = getMock(
  LUCK_DRAW_PATH + "/lotteryTurntable/prizeLog"
);
// 7.9.0 领券模板 // 获取标准活动和模板
export const standardActivityGet = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/standard/activity/get"
);
// 7.9.0 领券模板 // 获取标准活动奖品
export const standardActivityGiftGet = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/standard/activity/gift/get"
);
// 7.9.1 800度送会员
// 电量记录
export const chargeActivityRecord = postMock(
  LUCK_DRAW_PATH + "/chargeActivityRecord/list"
);
// 电量记录
export const chargeActivityRecordRead = postMock(
  LUCK_DRAW_PATH + "/chargeActivityRecord/read"
);
// 根据手机号获取用户Idv1.13.0
export const userIdGet = postMock(LUCK_DRAW_PATH + "/userId/get");
// 参与新用户注册有礼活动
export const signGiftGet = postMock(LUCK_DRAW_PATH + "/activity/signGift/get");
// 获取用户年度账单
export const annualBillGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/annual/bill/get"
);
// 获取年度账单奖励
export const annualBillGift = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/annual/bill/gift"
);

// 7.11.0
// 2022新年 扫星星活动和用户详情
export const scanStarInfoNew = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/scanStar/info"
);
//  2022新年  扫星星
export const scanStarScanNew = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/scanStar/scan"
);
//  2022新年  扫星星领取奖励
export const receiveScanStarScanNew = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/scanStar/receive/prize"
);

// 7.11.8
// 会员专属活动
export const memberLotteryInfo = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/member/lotteryTurntable/info"
);
// 会员专属活动抽奖
export const memberLotteryInfoLottery = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/member/lotteryTurntable/lottery"
);
// 会员专属活动所有人记录
export const memberLotteryPrizeLog = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/member/lotteryTurntable/prizeLog"
);
// 会员专属活动 获取用户数据
export const memberLotteryuserData = getMock(
  LUCK_DRAW_PATH_NEWPOINT + "/member/lotteryTurntable/userData"
);
// 低碳报告数据
export const lowCarbonGet = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/low/carbon/report/get"
);
// 获取徽章
export const badgeGet = postMock(LUCK_DRAW_PATH_NEWPOINT + "/badge/get");
// 绿电分享
export const greenShareIndex = postMock(
  LUCK_DRAW_PATH_NEWPOINT + "/greenpower/share/index"
);

export {
  queryDateByStubid,
  recognitionLicensePlate,
  elseCarSubmit,
  geCarSeacrh,
  getAllBrand,
  saveCarInfo,
  discernYard,
  carCerList,
  webLiveEnd,
  webLiveStart,
  getCarouserPicBo,
  getRewardInfoList,
  rewardWebLive,
  getUserIntegral,
  getUserSign,
  getImUserId,
  commitInviteTask,
  signInActivityPokerCards,
  signInActivityGetSignInInfo,
  checkIsJoinSignInActivity,
  joinSignInActivity,
  shakeActivityCardDetail,
  shakeActivityVipCoupon,
  shakeActivityDetail,
  shakeActivityGiveHelp,
  shakeActivityGoodLogList,
  shakeActivityCoupon,
  shakeActivityShare,
  shakeActivitygiftSummaryList,
  shakeActivityCarouselList,
  shakeActivityDrawLottery,
  shakeActivityGoodsFind,
  shakeActivityCardExchange,
  shakeActivityGiftRecordFind,
  getWxUser,
  WX_PAYMENT_URL,
  chargeTeamHitTeamRetreat,
  chargeTeamHitSuccessRecordGet,
  chargeTeamHitActivityInfoGet,
  chargeTeamHitRankmMoneyGet,
  chargeTeamHitRankGet,
  chargeTeamHitTeamUpdateName,
  chargeTeamHitPrizeRead,
  userGetBaseInfo,
  chargeTeamHitSuccessTeamGet,
  chargeTeamHitActivitySimpleInfoGet,
  chargeTeamHitTeamJoin,
  chargeTeamHitRandomTeammateAdd,
  chargeTeamHitRandomTeammateGet,
  chargeTeamHitUserRandomForm,
  chargeTeamHitUserFormTeam,
  chargeTeamHitSprintTaskOpen,
  chargeTeamHitSuccessTeamReadTask,
  chargeTeamHitShareInfoGet,
  chargeTeamHitUserChargeLogs,
  chargeTeamHitMessageAdd,
  chargeTeamHitMessageList,
  chargeTeamHitTeammateBreak,
  questionnaireGetCoupons,
  saveQuestionnaire,
  getQuestionnaire,
  wechatBindWxUnbindWxUser,
  wechatBindWxGetWxUser,
  wechatBindWxBindUser,
  wechatBindWxSendSms,
  chargeSendRedPacketGetVoucher,
  chargeSendRedPacketGetinfo,
  getUserRealNameFlag,
  getIintegralList,
  inviterUser,
  inviterUserCheck,
  exchangeGoods,
  getStarManagerUserInfo,
  getExchangeGoodsInfo,
  getIntegralList,
  getUserExtraInfo,
  givePrize,
  setVipTag,
  getVipTag,
  starManagerGetPrize,
  getInviterUser,
  getStorRank,
  starManagerGetInfo,
  scanStarGetPrize,
  scanStarScan,
  scanStarGetActivityInfo,
  userLottyActivityLotty,
  userLottyChanceGet,
  userIntegralAdd,
  signInviteCodeGet,
  getRecommendCount,
  wxImageSave,
  getWxImage,
  getUserDetail,
  getRedPackage,
  getLotteryChance,
  addressInfos,
  myGiftLists,
  getUserAddress,
  getPrizeInfo,
  wxShare,
  getPrizeList,
  getUserLotty,
  getValiCode,
  register,
  getCarouselList,
  addPrize,
  getPhone,
  getActivity,
  getAdvertisments,
  loginExUser,
  getActivityInfoUser,
  vipFissionLogin,
  vipFissionInviteList,
  payment,
  payOrderUpdate,
  inviteUser,
  getSystemInfo
};



// WEBPACK FOOTER //
// ./src/starcharge/mock/mock.js